import { FC, useEffect } from 'react';
import { PageProps } from 'shared/defines';
import { Link } from 'react-router-dom';

const InvalidPage: FC<PageProps> = ({ title }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <div className="w-full flex-1 flex flex-col justify-center gap-8 font-aeonik">
      <div className="flex flex-col">
        <div className="w-full flex gap-5">
          <div className="w-1.5 h-1.5 rounded-1.25 bg-green-laser"></div>
          <div className="flex-1 text-[4.375rem]/[4.375rem] -mt-2 font-medium text-green-laser">Oops!</div>
          <div className="w-1.5 h-1.5 rounded-1.25 bg-green-laser"></div>
        </div>
        <div className="text-[2.125rem]/[2.125rem] sm:text-[3.1rem]/[3.4rem] mt-10 mx-6.5 font-medium">
          We experienced an issue, please start over
        </div>
      </div>
      <Link to="/sign" className="text-[1.25rem] p-1 w-fit mx-6 text-green-laser hover:opacity-70 focus:opacity-50">
        Start over
      </Link>
    </div>
  );
};

export default InvalidPage;
